import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  billDateRange: {
    start: '',
    end: ''
  },
  billType: 1
};
var initForm2 = {
  billDateRange: {
    start: '',
    end: ''
  },
  billType: 2
};
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
export default {
  meta: {
    title: '账单查询',
    auth: true,
    authorityValue: 'store-store-bill-list'
  },
  name: 'bill',
  data: function data() {
    var _this = this;

    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'bills',
        params: cloneDeep(initForm),
        parser: function parser(res) {
          _this.extraData = res.extraData;
          return res;
        }
      },
      initForm2: initForm2,
      form2: cloneDeep(initForm2),
      request2: {
        api: 'bills',
        params: cloneDeep(initForm2)
      },
      total: 0,
      active: '1',
      SelectionChange: [],
      extraData: {},
      columns: [],
      xlsxData: []
    };
  },
  filters: {
    filterAmount: function filterAmount(row) {
      return new Number(row.incomeAmount - row.expendAmount).toFixed(2);
    }
  },
  computed: {
    paramsComputed: function paramsComputed() {
      var params = _objectSpread({
        billType: 1
      }, this.form);

      var i = Number(this.active);

      if (i == 2) {
        var date = params['billDateRange'] ? params['billDateRange'] : new Date();
        params['billDateRange'] = {
          start: dayjs(date).format('YYYY-MM'),
          end: dayjs(date).format('YYYY-MM')
        };
      }

      params.billType = i;
      console.log(params);
      return params;
    }
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.SelectionChange = e;
    },
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    handleSearch2: function handleSearch2(values) {
      this.$set(this.request2, 'params', values);
      this.$refs.baseTable.loadData();
    },
    tabClick: function tabClick(e) {},
    download: function download(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var form, columns, data, res, arr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form = {
                  statrt: '',
                  end: ''
                };

                if (row.date) {
                  form.statrt = row.date;
                  form.end = row.date;
                }

                columns = [{
                  label: '订单编号',
                  prop: 'orderNo'
                }, {
                  label: '单据编号',
                  prop: 'relationNo'
                }, {
                  label: '单据类型',
                  prop: 'billType'
                }, {
                  label: '商品编号',
                  prop: 'goodsNo'
                }, {
                  label: '商户订单号',
                  prop: 'orderNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '结算状态',
                  prop: 'status'
                }, {
                  label: '费用结算时间',
                  prop: 'date'
                }, {
                  label: '费用项',
                  prop: 'feeType'
                }, {
                  label: '金额',
                  prop: 'money'
                }, {
                  label: '币种',
                  prop: 'cny'
                }, {
                  label: '商家应收/应付',
                  prop: 'inOrPay'
                }, {
                  label: '店铺号',
                  prop: 'consigneeName'
                }, {
                  label: '收支方向',
                  prop: 'incomeType'
                }, {
                  label: '商品数量',
                  prop: 'goodsCount'
                }];
                data = [];
                _context2.next = 6;
                return _this2.$api.exportBills({
                  billDateRange: form,
                  pageSize: 99999,
                  billType: 1
                });

              case 6:
                res = _context2.sent;
                res.records.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(v) {
                    var obj, obj1, obj2;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            obj = {};
                            obj1 = {};
                            obj2 = {};

                            if (v.subtotalAmount > 0) {
                              obj = _objectSpread({}, v);

                              _this2.$set(obj, 'status', obj.goodsAmountSettled ? '已结算' : '未结算');

                              _this2.$set(obj, 'feeType', '货款');

                              _this2.$set(obj, 'incomeType', '收入');

                              _this2.$set(obj, 'billType', obj.billType == 1 ? '订单' : '退款单');

                              _this2.$set(obj, 'cny', 'CNY');

                              _this2.$set(obj, 'inOrPay', '应收');

                              _this2.$set(obj, 'money', obj.subtotalAmount);

                              _this2.$set(obj, 'date', obj.goodsAmountSettlementTime);
                            }

                            if (v.cashbackAmount > 0) {
                              obj1 = _objectSpread({}, v);

                              _this2.$set(obj1, 'status', obj1.cashbackSettled ? '已结算' : '未结算'); // this.$set(obj1, 'feeType', '返现')


                              _this2.$set(obj1, 'incomeType', '支出');

                              _this2.$set(obj1, 'billType', obj1.billType == 1 ? '订单' : '退款单');

                              _this2.$set(obj1, 'cny', 'CNY');

                              _this2.$set(obj1, 'inOrPay', '应付');

                              _this2.$set(obj1, 'money', -obj1.cashbackAmount);

                              _this2.$set(obj1, 'date', obj1.cashbackSettlementTime);
                            }

                            if (v.commissionAmount > 0) {
                              obj2 = _objectSpread({}, v);

                              _this2.$set(obj2, 'status', obj2.commissionSettled ? '已结算' : '未结算');

                              _this2.$set(obj2, 'feeType', '佣金');

                              _this2.$set(obj2, 'incomeType', '支出');

                              _this2.$set(obj2, 'billType', obj2.billType == 1 ? '订单' : '退款单');

                              _this2.$set(obj2, 'cny', 'CNY');

                              _this2.$set(obj2, 'inOrPay', '应付');

                              _this2.$set(obj2, 'money', -obj2.commissionAmount);

                              _this2.$set(obj2, 'date', obj2.commissionSettlementTime);
                            }

                            data.push(obj);
                            data.push(obj1);
                            data.push(obj2);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                arr = data.filter(function (e) {
                  return JSON.stringify(e) !== '{}';
                });

                _this2.xlsxExport(columns, arr, '日账单');

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    download2: function download2(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var form, columns, data, res, arr;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                form = {
                  statrt: '',
                  end: ''
                };

                if (row.date) {
                  form.statrt = row.date;
                  form.end = row.date;
                }

                columns = [{
                  label: '订单编号',
                  prop: 'orderNo'
                }, {
                  label: '单据编号',
                  prop: 'relationNo'
                }, {
                  label: '单据类型',
                  prop: 'billType'
                }, {
                  label: '商品编号',
                  prop: 'goodsNo'
                }, {
                  label: '商户订单号',
                  prop: 'orderNo'
                }, {
                  label: '商品名称',
                  prop: 'goodsName'
                }, {
                  label: '结算状态',
                  prop: 'status'
                }, {
                  label: '费用结算时间',
                  prop: 'date'
                }, {
                  label: '费用项',
                  prop: 'feeType'
                }, {
                  label: '金额',
                  prop: 'money'
                }, {
                  label: '币种',
                  prop: 'cny'
                }, {
                  label: '商家应收/应付',
                  prop: 'inOrPay'
                }, {
                  label: '店铺号',
                  prop: 'consigneeName'
                }, {
                  label: '收支方向',
                  prop: 'incomeType'
                }, {
                  label: '商品数量',
                  prop: 'goodsCount'
                }];
                data = [];
                _context4.next = 6;
                return _this3.$api.exportBills({
                  billDateRange: form,
                  pageSize: 99999,
                  billType: 2
                });

              case 6:
                res = _context4.sent;
                res.records.forEach( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(v) {
                    var obj, obj1, obj2;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            obj = {};
                            obj1 = {};
                            obj2 = {};

                            if (v.subtotalAmount > 0) {
                              obj = _objectSpread({}, v);

                              _this3.$set(obj, 'status', obj.goodsAmountSettled ? '已结算' : '未结算');

                              _this3.$set(obj, 'feeType', '货款');

                              _this3.$set(obj, 'incomeType', '收入');

                              _this3.$set(obj, 'billType', obj.billType == 1 ? '订单' : '退款单');

                              _this3.$set(obj, 'cny', 'CNY');

                              _this3.$set(obj, 'inOrPay', '应收');

                              _this3.$set(obj, 'money', obj.subtotalAmount);

                              _this3.$set(obj, 'date', obj.goodsAmountSettlementTime);
                            }

                            if (v.cashbackAmount > 0) {
                              obj1 = _objectSpread({}, v);

                              _this3.$set(obj1, 'status', obj1.cashbackSettled ? '已结算' : '未结算'); // this.$set(obj1, 'feeType', '返现')


                              _this3.$set(obj1, 'incomeType', '支出');

                              _this3.$set(obj1, 'billType', obj1.billType == 1 ? '订单' : '退款单');

                              _this3.$set(obj1, 'cny', 'CNY');

                              _this3.$set(obj1, 'inOrPay', '应付');

                              _this3.$set(obj1, 'money', -obj1.cashbackAmount);

                              _this3.$set(obj1, 'date', obj1.cashbackSettlementTime);
                            }

                            if (v.commissionAmount > 0) {
                              obj2 = _objectSpread({}, v);

                              _this3.$set(obj2, 'status', obj2.commissionSettled ? '已结算' : '未结算');

                              _this3.$set(obj2, 'feeType', '佣金');

                              _this3.$set(obj2, 'incomeType', '支出');

                              _this3.$set(obj2, 'billType', obj2.billType == 1 ? '订单' : '退款单');

                              _this3.$set(obj2, 'cny', 'CNY');

                              _this3.$set(obj2, 'inOrPay', '应付');

                              _this3.$set(obj2, 'money', -obj2.commissionAmount);

                              _this3.$set(obj2, 'date', obj2.commissionSettlementTime);
                            }

                            data.push(obj);
                            data.push(obj1);
                            data.push(obj2);

                          case 9:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                arr = data.filter(function (e) {
                  return JSON.stringify(e) !== '{}';
                });

                _this3.xlsxExport(columns, arr, '日账单');

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};